import { render, staticRenderFns } from "./InvoiceSend.vue?vue&type=template&id=56f8f336&scoped=true&"
import script from "./InvoiceSend.vue?vue&type=script&lang=js&"
export * from "./InvoiceSend.vue?vue&type=script&lang=js&"
import style1 from "./InvoiceSend.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f8f336",
  null
  
)

export default component.exports